<div style="display: flex; align-items: center; justify-content: space-between;">
    <div>
        <h4>Bogie Inspection History</h4>
    </div>
    <div style="text-align: right; cursor: pointer;">
        <i class="material-icons __close-button" (click)="onNoClick()" matTooltip="Close">close</i>
    </div>
</div>

<div style="display:flex; flex-direction:column; gap:10px; max-height: 70vh; overflow-y: auto; padding-right: 10px;">
    <ng-container *ngFor="let b of bogieHistoryDetails">
        <div class="inspection-card">
            <div class="meta-col">
                <div class="meta-row">
                    <span class="label">Date:</span>
                    <div class="value">
                        <div>{{ b.InspectionDate | date: 'dd MMM yyyy' }}</div>
                    </div>
                </div>
                <div class="meta-row">
                    <span class="label">SMU:</span>
                    <div class="value">
                        <div>{{ b.InspectionSMU ?? '-' }}</div>
                    </div>
                </div>
            </div>
            <div>
                <table class="table table--striped table--full-width" *ngIf="b?.BogieShim?.length; else noShimRows">
                    <thead>
                        <tr>
                            <th>Major Bogie</th>
                            <th>Shim Count</th>
                            <th>Comment</th>
                            <th>Images</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let a of b.BogieShim; let i = index">
                            <td>{{ a.BogieNumber }}</td>
                            <td>{{ a.ShimCount }} </td>
                            <td [attr.title]="a.Comment">{{ a.Comment || 'No Comment' | truncate:[18] }} </td>
                            <td style="display: flex;gap: 5px;">
                                <div *ngFor="let img of a.Images" >
                                    <img class="observation-image__photo" [src]="img.ImagePath" (click)="ViewInspectionImage(img.ImagePath, img.ImageId)"/>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <ng-template #noShimRows>
                    <div class="no-data">No bogie shim details available.</div>
                </ng-template>
            </div>
        </div>
    </ng-container>
</div>